import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { KeyRound, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/PasswordInput";
import { PW_RULE, pwError } from "@/components/ChangePasswordForm";
import { api, errMsg } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const bad = pwError(pw, confirm);
    if (bad) return setError(bad);
    setBusy(true);
    setError("");
    try { await api.post("/auth/reset-password", { token, password: pw }); setDone(true); }
    catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#FBF9F4] p-6" data-testid="reset-password-page">
      <div className="w-full max-w-sm bf-rise">
        <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#0F382C] text-[#F2B880]"><KeyRound className="h-6 w-6" /></div>
        <h1 className="font-display text-3xl font-extrabold text-[#0F382C]">Choose a new password</h1>
        {done ? (
          <div className="mt-6 space-y-4" data-testid="reset-password-done">
            <p className="text-sm text-muted-foreground">Your password has been changed. Sign in with your new password.</p>
            <Button asChild className="h-11 w-full rounded-full bg-[#0F382C] hover:bg-[#134E3A]"><Link to="/login" data-testid="reset-go-login-btn">Go to sign in</Link></Button>
          </div>
        ) : !token ? (
          <p className="mt-4 text-sm text-rose-700" data-testid="reset-password-no-token">This link is missing its code. Open the link from your email again, or ask for a new one on the sign-in page.</p>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="reset-password-form">
            <div className="space-y-1"><Label>New password</Label><PasswordInput required value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password" className="h-11 bg-white" data-testid="reset-new-input" />
              <p className="text-xs text-muted-foreground">{PW_RULE}</p></div>
            <div className="space-y-1"><Label>Confirm new password</Label><PasswordInput required value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" className="h-11 bg-white" data-testid="reset-confirm-input" /></div>
            {error && <div className="rounded-lg border border-rose-200 bg-rose-50 p-3 text-sm text-rose-700" data-testid="reset-error">{error}</div>}
            <Button type="submit" disabled={busy} className="h-11 w-full rounded-full bg-[#0F382C] hover:bg-[#134E3A]" data-testid="reset-submit-btn">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Save new password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
